(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    // Usa MutationObserver per aspettare il bottone se non è ancora nel DOM
    const btn = document.querySelector('.add-cart-button');
    if (btn) {
      init(btn);
    } else {
      const observer = new MutationObserver(function () {
        const btn = document.querySelector('.add-cart-button');
        if (btn) {
          observer.disconnect();
          init(btn);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  });

  function init(btn) {
    const optionalsContainer = document.getElementById('product-optionals');
    if (!optionalsContainer) return;
    btn.addEventListener('click', handleAddToCart);
  }

  function getMeasurementProperties() {
    const modal = document.querySelector('#modal-1');
    if (!modal) return {};
    const properties = {};
    modal.querySelectorAll('.custom-property-measurement__input input').forEach(function (input) {
      const value = input.value.trim();
      if (value !== '') {
        const key = input.name.replace('properties[', '').replace(']', '');
        properties[key] = value;
      }
    });
    return properties;
  }

  function handleAddToCart(e) {
    const checkedOptionals = document.querySelectorAll('.optional-checkbox:checked');
    if (checkedOptionals.length === 0) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const mainVariantInput = document.querySelector('input[name="id"]');
    const quantityInput = document.querySelector('input[name="quantity"]');
    if (!mainVariantInput) return;

    const mainVariantId = parseInt(mainVariantInput.value);
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    const properties = getMeasurementProperties();

    const mainItem = { id: mainVariantId, quantity: quantity };
    if (Object.keys(properties).length > 0) {
      mainItem.properties = properties;
    }

    const items = [mainItem];
    checkedOptionals.forEach(function (checkbox) {
      items.push({ id: parseInt(checkbox.dataset.variantId), quantity: 1 });
    });

    addItemsToCart(items);
  }

  async function addItemsToCart(items) {
    const btn = document.querySelector('.add-cart-button');
    if (btn) {
      btn.disabled = true;
      btn.classList.add('loading');
    }

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      const mainItem = items[0];
      const optionalItems = items.slice(1);

      const alreadyInCart = cart.items.some(function (cartItem) {
        return cartItem.variant_id === mainItem.id;
      });

      const itemsToAdd = alreadyInCart ? optionalItems : items;

      if (itemsToAdd.length === 0) {
        if (btn) { btn.disabled = false; btn.classList.remove('loading'); }
        return;
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Errore aggiunta al carrello');
      }

      window.location.href = '/cart';

    } catch (err) {
      console.error('[product-optionals]', err);
      alert('Errore: ' + err.message);
      if (btn) { btn.disabled = false; btn.classList.remove('loading'); }
    }
  }

})();